import React from "react";

export default ({msg}) => (
  <div className="notice notice__info">
    <span>{msg}</span>
  </div>
)
